import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { CustomerInteractionRealTimeMessagePayload } from "../real-time-notifications/real-time-notifications.model";

import { CustomerInteractionMarkRealTimeMessageAsShownPayload } from "./customer-interactions.model";

const ACTION_PREFIX = "[Customer Interactions]";
const MARK_ALERT_AS = "Mark Alert as";
const SUCCESS = "Success";
const FAIL = "Fail";
const GET_UNACKNOWLEDGED_MESSAGES = "Get Unacknowledged Messages";
const OPEN = "Open";
const TRIGGER_ALERT = "Trigger Alert";

const STATES = Object.freeze({
	SHOWN: "Shown",
	CONFIRMED: "Confirmed",
	LOGGED_OUT: "LoggedOut",
	DEPOSIT_LIMIT: "DepositLimit",
	MORE_INFO: "MoreInfo",
});

export const CUSTOMER_INTERACTION_ACTION_TYPE = Object.freeze({
	getUnacknowledgedMessages: `${ACTION_PREFIX} ${GET_UNACKNOWLEDGED_MESSAGES}`,
	getUnacknowledgedMessagesSuccess: `${ACTION_PREFIX} ${GET_UNACKNOWLEDGED_MESSAGES} ${SUCCESS}`,
	getUnacknowledgedMessagesFail: `${ACTION_PREFIX} ${GET_UNACKNOWLEDGED_MESSAGES} ${FAIL}`,
	markAsShown: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.SHOWN}`,
	markAsShownFail: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.SHOWN} ${FAIL}`,
	markAsShownSuccess: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.SHOWN} ${SUCCESS}`,
	markAsConfirmed: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.CONFIRMED}`,
	markAsConfirmedFail: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.CONFIRMED} ${FAIL}`,
	markAsConfirmedSuccess: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.CONFIRMED} ${SUCCESS}`,
	markAsLoggedOut: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.LOGGED_OUT}`,
	markAsLoggedOutFail: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.LOGGED_OUT} ${FAIL}`,
	markAsLoggedOutSuccess: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.LOGGED_OUT} ${SUCCESS}`,
	markAsDepositLimit: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.DEPOSIT_LIMIT}`,
	markAsDepositLimitFail: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.DEPOSIT_LIMIT} ${FAIL}`,
	markAsDepositLimitSuccess: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.DEPOSIT_LIMIT} ${SUCCESS}`,
	markAsMoreInfo: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.MORE_INFO}`,
	markAsMoreInfoFail: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.MORE_INFO} ${FAIL}`,
	markAsMoreInfoSuccess: `${ACTION_PREFIX} ${MARK_ALERT_AS} ${STATES.MORE_INFO} ${SUCCESS}`,
	showUnacknowledgedMessages: `${ACTION_PREFIX} Show Unacknowledged Messages`,
	openAlert: `${ACTION_PREFIX} ${OPEN} ${TRIGGER_ALERT} ${SYNC_SUFFIX}`,
});

export namespace CustomerInteractionsAction {
	export const getUnacknowledgedMessages = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.getUnacknowledgedMessages);

	export const getUnacknowledgedMessagesSuccess = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.getUnacknowledgedMessagesSuccess,
		(payload: CustomerInteractionRealTimeMessagePayload[]) => ({ payload })
	);

	export const getUnacknowledgedMessagesFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.getUnacknowledgedMessagesFail,
		(payload: AppError) => ({ payload })
	);

	export const showUnacknowledgedMessages = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.showUnacknowledgedMessages);

	export const openAlert = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.openAlert,
		(payload: CustomerInteractionRealTimeMessagePayload) => ({ payload })
	);

	export const markAlertAsShown = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsShown,
		(payload: CustomerInteractionMarkRealTimeMessageAsShownPayload) => ({ payload })
	);

	export const markAlertAsShownSuccess = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.markAsShownSuccess);

	export const markAlertAsShownFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsShownFail,
		(payload: AppError) => ({ payload })
	);

	export const markAlertAsConfirmed = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsConfirmed,
		(payload: string) => ({ payload })
	);

	export const markAlertAsConfirmedSuccess = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.markAsConfirmedSuccess);

	export const markAlertAsConfirmedFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsConfirmedFail,
		(payload: AppError) => ({ payload })
	);

	export const markAlertAsLoggedOut = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsLoggedOut,
		(payload: string) => ({ payload })
	);

	export const markAlertAsLoggedOutSuccess = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.markAsLoggedOutSuccess);

	export const markAlertAsLoggedOutFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsLoggedOutFail,
		(payload: AppError) => ({ payload })
	);

	export const markAlertAsDepositLimit = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsDepositLimit,
		(payload: string) => ({ payload })
	);

	export const markAlertAsDepositLimitSuccess = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsDepositLimitSuccess
	);

	export const markAlertAsDepositLimitFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsDepositLimitFail,
		(payload: AppError) => ({ payload })
	);

	export const markAlertAsMoreInfo = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsMoreInfo,
		(payload: string) => ({ payload })
	);

	export const markAlertAsMoreInfoSuccess = createAction(CUSTOMER_INTERACTION_ACTION_TYPE.markAsMoreInfoSuccess);

	export const markAlertAsMoreInfoFail = createAction(
		CUSTOMER_INTERACTION_ACTION_TYPE.markAsMoreInfoFail,
		(payload: AppError) => ({ payload })
	);
}
